import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';
import NewsletterSignup from './NewsletterSignup';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-col">
          <div className="footer-brand">
            <img src="/ciba-logo.jpg" alt="CIBA Logo" className="brand-logo" />
            <div>
              <div className="footer-brand-title">Cayman Islands Basketball Association</div>
              <div className="footer-brand-sub">The Home of Basketball in the Cayman Islands</div>
            </div>
          </div>
          <p className="footer-desc">
            A non-profit organization and the governing body for basketball in the Cayman Islands,
            serving more than 1,500 active athletes through leagues, national teams and development programs.
          </p>
          <div className="footer-social">
            <a href="https://www.facebook.com/caymanbasketball" target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={18} /></a>
            <a href="https://instagram.com/345basketball" target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="https://www.youtube.com/@CaymanIslandsBasketball" target="_blank" rel="noreferrer" aria-label="YouTube"><Youtube size={18} /></a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <Link to="/news">News</Link>
          <Link to="/about-us">About Us</Link>
          <Link to="/page/events">Events</Link>
          <a href="http://ciba.web.geniussports.com/competitions/?cu=CYBA/schedule" target="_blank" rel="noreferrer">Results & Stats</a>
          <Link to="/page/rules-and-regulations">Rules & Regulations</Link>
          <Link to="/page/sponsors">Sponsors</Link>
        </div>

        <div className="footer-col">
          <h4>Leagues</h4>
          <Link to="/page/national-mens-basketball-league">National Men's League</Link>
          <Link to="/page/national-womens-league">National Women's League</Link>
          <Link to="/page/under-19">Under 19 Leagues</Link>
          <Link to="/page/under16">Under 16 Leagues</Link>
          <Link to="/page/under-13">13 & Under Leagues</Link>
          <Link to="/page/corporate-basketball-league">Corporate League</Link>
          <Link to="/page/kings-development-program">Kings Development Program</Link>
        </div>

        <div className="footer-col">
          <h4>Contact</h4>
          <div className="footer-contact"><MapPin size={16} /><span>P.O. Box 186, Grand Cayman,<br />KY1-1104, Cayman Islands</span></div>
          <div className="footer-contact"><Mail size={16} /><a href="mailto:info@caymanbasketball.com">info@caymanbasketball.com</a></div>
          <div className="footer-contact"><Phone size={16} /><a href="tel:13459165083">1-345-916-5083</a></div>
          <h4 className="footer-newsletter-title">Newsletter</h4>
          <p className="footer-newsletter-desc">Get notified when new stories are posted.</p>
          <NewsletterSignup compact />
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <span>© {new Date().getFullYear()} Cayman Islands Basketball Association. All rights reserved.</span>
          <Link to="/admin" className="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
